import {Component, OnInit} from '@angular/core'
import {GamesPlaygroundService} from "../../service/games-playground/games-playground.service";
import {providersImages} from "../../config/providers-images.config";
import {MainTabsService} from "../../service/main-tabs.service";
import {AuthenticationService} from "../../modules/auth/_services/authentication.service";
import {Router} from "@angular/router";
import {UserBalanceService} from "../../service/users/userBalance.service";

@Component({
  selector: 'app-main-tabs',
  templateUrl: './main-tabs.component.html',
  styleUrls: ['./main-tabs.component.scss']
})
export class MainTabsComponent implements OnInit {
  providersImages = providersImages;

  constructor(private mainTabsService: MainTabsService,
              private userBalanceService: UserBalanceService,
              private authenticationService: AuthenticationService,
              private gamesPlaygroundService: GamesPlaygroundService) { }

  ngOnInit() {
    this.updateGameInfo();
    this.gamesPlaygroundService.onGamesUpdated.subscribe(val => {
      this.updateGameInfo();
    });
    this.gamesPlaygroundService.updateGames.subscribe(val => {
      this.updateGameInfo();
    });
  }

  updateGameInfo() {
    this.getTitleImg();
    this.getTitleLogo();
  }

  onShowDepositTab(): void {
    this.onCloseTabs();
    this.mainTabsService.makeDepositTabActive();
    //(this.depositAmount.nativeElement as HTMLInputElement).focus();
  }

  isDepositTabActive(): boolean {
    return this.mainTabsService.isDepositTabActive();
  }

  isRedeemTabActive(): boolean {
    return this.mainTabsService.isRedeemTabActive();
  }

  isUserLogged() {
    return this.authenticationService.isUserLogged();
  }

  onShowRedeemTab(): void {
    if (this.isUserLogged()) {
      this.getGameBalance();
    }
    this.onCloseTabs();
    this.mainTabsService.makeRedeemTabActive();
    //(this.redeemAmount.nativeElement as HTMLInputElement).focus();
  }

  getGameBalance() {
    this.userBalanceService.initGameBalanceRequest(this.getSelectedProviderId());
  }

  getSelectedProviderId() {
    return this.gamesPlaygroundService.getSelectedProviderId();
  }

  onCloseTabs(): void {
    this.mainTabsService.isNoTabsActive();
    this.authenticationService.resetLoginBtnText();
  }

  getProviderTitleImg(): string {
    if (this.getProviderShortName()) {
      const shortName = this.getProviderShortName();
      const providerInfo = this.providersImages.find(provider => provider.shortName === shortName);
      return providerInfo.imageTitle;
    }
  }

  getProviderImg(): string {
    if (this.getProviderShortName()) {
      const shortName = this.getProviderShortName();
      const providerInfo = this.providersImages.find(provider => provider.shortName === shortName);
      return providerInfo.image;
    }
  }

  getTitleImgAdditionalStyle() {
    const styles: {height?; left?;} = {};
    if (this.getProviderShortName()) {
      const shortName = this.getProviderShortName();
      const providerInfo = this.providersImages.find(provider => provider.shortName === shortName);
      if (providerInfo.titleHeight) {
        styles.height = providerInfo.titleHeight + 'em'
      }
      if (providerInfo.titleLeft) {
        styles.left = providerInfo.titleLeft + '%'
      }
    }
    return styles;
  }

  getTitleImg() {
    document.getElementById('gameTitleImg').setAttribute('src', '');
    const styles: {height?; left?;} = {};
    let url;
    if (this.getProviderShortName()) {
      const shortName = this.getProviderShortName();
      const providerInfo = this.providersImages.find(provider => provider.shortName === shortName);
      if (providerInfo.titleHeight) {
        styles.height = providerInfo.titleHeight + 'em'
      }
      if (providerInfo.titleLeft) {
        styles.left = providerInfo.titleLeft + '%'
      }
      url = providerInfo.imageTitle;
    }

    document.getElementById('gameTitleImg').setAttribute('style', `height: ${styles.height ? styles.height : '2em'}; left: ${styles.left ? styles.left : '36%'}`);
    document.getElementById('gameTitleImg').setAttribute('src', '../../../assets/images/games-playground/' + url);
  }

  getTitleLogo() {
    document.getElementById('gameTitleLogo').setAttribute('src', '');
    const styles: {width?; height?; top?; left?; borderRadius?} = {};
    let url;
    if (this.getProviderShortName()) {
      const shortName = this.getProviderShortName();
      const providerInfo = this.providersImages.find(provider => provider.shortName === shortName);

      if (providerInfo.imgWidth) {
        styles.width = providerInfo.imgWidth+'%'
      }
      if (providerInfo.imgHeight) {
        styles.height = providerInfo.imgHeight+'%'
      }
      if (providerInfo.imgTop) {
        styles.top = providerInfo.imgTop+'%'
      }
      if (providerInfo.imgLeft) {
        styles.left = providerInfo.imgLeft+'%'
      }
      if (providerInfo.bRadius) {
        styles.borderRadius = providerInfo.bRadius+'%'
      }
      url = providerInfo.image;
    }
    document.getElementById('gameTitleLogo').setAttribute('style',
      `height: ${styles.height ? styles.height : '100%'}; 
             width: ${styles.width ? styles.width : '100%'}; 
             border-radius: ${styles.borderRadius ? styles.borderRadius : '50%'}; 
             top: ${styles.top ? styles.top : 'unset'}; 
             left: ${styles.left ? styles.left : '50%'}`);
    document.getElementById('gameTitleLogo').setAttribute('src', '../../../assets/images/games-playground/' + url);
  }

  getProviderImgStyle() {
    const styles: {width?; height?; top?; left?; borderRadius?} = {};
    if (this.getProviderShortName()) {
      const shortName = this.getProviderShortName();
      const providerInfo = this.providersImages.find(provider => provider.shortName === shortName);

      if (providerInfo.imgWidth) {
        styles.width = providerInfo.imgWidth+'%'
      }
      if (providerInfo.imgHeight) {
        styles.height = providerInfo.imgHeight+'%'
      }
      if (providerInfo.imgTop) {
        styles.top = providerInfo.imgTop+'%'
      }
      if (providerInfo.imgLeft) {
        styles.left = providerInfo.imgLeft+'%'
      }
      if (providerInfo.bRadius) {
        styles.borderRadius = providerInfo.bRadius+'%'
      }
    }
    return styles;
  }

  getProvider() {
    return this.gamesPlaygroundService.getSelectedProvider();
  }

  getProviderName() {
    return this.gamesPlaygroundService.getSelectedProviderName();
  }

  getProviderShortName() {
    if (this.getProvider() && this.getProvider().short_name) {
      return this.getProvider().short_name;
    }
  }
}
